import { gql } from '@apollo/client';

export const ENTER_PROMO_CODE = gql`
  mutation EnterPromoCode($promoCode: String!) {
    enterPromoCode(promoCode: $promoCode) {
      name
    }
  }
`;
